:host {
  width: 100%;

  .progress-tracker-step {
    position: relative;
    width: 100%;
    min-width: wink-rem(4);
    height: 100%;
    min-height: wink-rem(4);
    color: var(--semantic-color-text-default);

    &::before {
      content: '';
      position: absolute;
      z-index: 0;
      top: wink-rem(3.2);
      left: wink-rem(1);
      width: 0;
      height: 100%;
      border-top: var-rem(--progress-tracker-step__line-horizontal__border-size, 0) solid
        var(--progress-tracker-step__line__border-color, var(--semantic-components-progress-tracker-default));
      border-left: var-rem(--progress-tracker-step__line-vertical__border-size, 0.4) solid
        var(--progress-tracker-step__line__border-color, var(--semantic-components-progress-tracker-default));

      @include media('from-sm') {
        left: wink-rem(1.2);
      }
    }

    & .counter,
    & .counter::before {
      @include font--caption-bold;

      content: '';
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      width: wink-rem(2.4);
      height: wink-rem(2.4);

      @include media('from-sm') {
        width: wink-rem(2.8);
        height: wink-rem(2.8);
      }
    }

    & .counter {
      z-index: 4;
      top: var-rem(--semantic-spacing-md);
      left: 0;
      color: var(--progress-tracker-step__counter__color, var(--semantic-color-text-default));
      background-color: var(--progress-tracker-step__counter__bgc, var(--semantic-components-progress-tracker-default));
    }

    & .counter::before {
      z-index: 2;
      top: 0;
      left: 0;
      background-color: var(--progress-tracker-step__counter--active-border__bgc, transparent);
    }

    .content {
      margin-top: 0;
      margin-left: wink-rem(4.8);
      background-color: var(--semantic-components-box-color-background-main-box-default);
      border-radius: var-rem(--semantic-components-box-radius-main-box);
      padding: var-rem(--semantic-components-box-padding-main-box);
      border: var-rem(--semantic-border-sm) solid var(--semantic-components-box-color-border-standard);
    }
  }
}

:host([direction='horizontal']) {
  --progress-tracker-step__line-vertical__border-size: 0;
  --progress-tracker-step__line-horizontal__border-size: 0.4;

  .progress-tracker-step {
    &::before {
      top: wink-rem(1);
      left: wink-rem(1.6);
      width: 100%;
      height: 0;

      @include media('from-sm') {
        top: wink-rem(1.2);
        left: wink-rem(1.6);
      }
    }

    & .counter {
      top: 0;
      left: 0;
    }

    & .counter::before {
      top: 0;
      left: 0;
    }

    & .counter::after {
      top: 0;
      left: 0;
    }

    .content {
      margin-top: 0;
      margin-left: 0;
      padding: 0;
    }
  }
}

:host([is-active='true'][is-completed='false']) {
  --progress-tracker-step__counter__bgc: var(--semantic-color-background-canvas-default);
}

:host([is-completed='true']),
:host([is-active='true'][is-completed='true']) {
  --wink-icon-color: var(--semantic-color-text-on-brand);
  --progress-tracker-step__line__border-color: var(--semantic-color-background-canvas-brand);
  --progress-tracker-step__counter__color: var(--semantic-color-text-on-brand);
  --progress-tracker-step__counter__bgc: var(--semantic-color-background-canvas-brand);
  --progress-tracker-step__counter--active-border__bgc: transparent;
}

:host([is-last='true']),
:host([is-last='true'][direction='horizontal']) {
  --progress-tracker-step__line-vertical__border-size: 0;
  --progress-tracker-step__line-horizontal__border-size: 0;
}

:host([is-last='true'][direction='horizontal']) {
  width: wink-rem(2.4);

  @include media('from-sm') {
    width: wink-rem(2.8);
  }
}
